import { OSM_AMENITY_META } from "./OsmAmenityLayers";

// Chip row to toggle the auto-harvested OSM amenity layers (off by default).
export function AmenityToggles({ visible = {}, onToggle, available = {}, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid="amenity-toggles">
      {Object.keys(OSM_AMENITY_META).map((k) => {
        const meta = OSM_AMENITY_META[k];
        const count = available[k] || 0;
        const on = !!visible[k];
        return (
          <button key={k} type="button" onClick={() => onToggle(k)} data-testid={`amenity-toggle-${k}`}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-semibold border transition-colors"
            style={on
              ? { background: meta.color, borderColor: meta.color, color: "#fff" }
              : { borderColor: "rgba(148,163,184,0.4)", color: "inherit" }}>
            <span className="w-2 h-2 rounded-full" style={{ background: meta.color }} />
            {meta.label}{count ? ` (${count})` : ""}
          </button>
        );
      })}
    </div>
  );
}
